module.exports = __webpack_public_path__ + "static/media/tableTennis.9db27f77.svg";